<template>
  <svg
    v-svg
    class="icon"
    :data-testid="`icon-${name}`"
    :symbol="`icon-${name}`"
    :size="`0 0 ${size_} ${size_}`"
    :fill="color"
  >
    <title v-if="title">{{ title }}</title>
  </svg>
</template>

<script>
const VALID_SIZES = [
  'xs',
  'sm',
  'md',
  'lg',
  'xl',
  'xxl',
  'xxxl'
]

export default {
  props: {
    name: String,
    title: {
      type: String,
      default: ''
    },
    /**
        * Set the icon size
        * @param 'xl', 'lg', 'md', 'sm', 'xs'
        * @default 'md'
        */
    size: {
      type: String,
      default: 'md',
      validator(val) {
        return !val || VALID_SIZES.includes(val)
      }
    },
    customSize: {
      type: Number,
      default: null
    },
    /**
        * Set the icon color.
        * @type {Boolean}
        * @default 'currentColor'
        */
    color: {
      type: String,
      default: 'currentColor'
    }
  },
  computed: {
    size_() {
      if (this.customSize) return this.customSize

      switch (this.size) {
        case 'xxxl':
          return 48
        case 'xxl':
          return 30
        case 'xl':
          return 24
        case 'lg':
          return 16
        case 'md':
          return 14
        case 'sm':
          return 12
        case 'xs':
          return 10
        default:
          return 14 // md
      }
    }
  }
}
</script>
